import React from 'react';
import { connect } from 'react-redux';

import {
  BrowserRouter as Router,
  Route as ReactRouterRoute,
  Redirect,
  Switch,
} from 'react-router-dom';

import {
  Admin,
  Root,
  Home,
  MasterRoutes,
  Login,
  User,
  SystemNotification,
  GraphiQL,
} from './components';

import JobRoutes from './modules/job/JobRoutes';
import AdminExport from './modules/admin/AdminExport';
import FinancialRoutes from './modules/financial/FinancialRoutes';
import TutorRoutes from './modules/admin/tutor/TutorRoutes';
import StudentRoutes from './modules/admin/student/StudentRoutes';
import TutoringCompanyRoutes from './modules/admin/company/TutoringCompanyRoutes';

const InvalidPath = () => <div style={{ paddng: 20 }}>Path Not found</div>;

const Route = ({ component: Container, authenticated, ...rest }) => {
  let render = null;

  if (Container) {
    render = props => {
      if (authenticated) {
        return <Container {...rest} {...props} />;
      }

      return (
        <Redirect
          to={{
            pathname: '/login',
            // state: { from: routeProps.location },
          }}
        />
      );
    };
  }

  return <ReactRouterRoute {...rest} render={render} />;
};

const App = ({ authenticated }) => (
  <div>
    <Router>
      <Root>
        <Switch>
          <Route
            exact
            path="/"
            breadcrumb={false}
            component={Home}
            authenticated={authenticated}
          />
          <ReactRouterRoute exact path="/login" component={Login} />
          {MasterRoutes}
          {FinancialRoutes}
          <Route
            path="/admin/user"
            exact
            title="Users"
            component={Admin.Users}
            authenticated={authenticated}
          />
          <Route
            path="/admin/user/:nodeId"
            exact
            component={User}
            title="User"
            authenticated={authenticated}
          />
          {JobRoutes}
          {StudentRoutes}
          {TutorRoutes}
          {TutoringCompanyRoutes}

          <Route
            path="/admin/export"
            title="Export"
            exact
            component={AdminExport}
            authenticated={authenticated}
          />
          <Route
            path="/admin/notification/push"
            title="Push Notifications"
            exact
            component={Admin.PushNotification}
            authenticated={authenticated}
          />
          <Route
            path="/admin/activities"
            title="Activities"
            exact
            component={Admin.Activities}
            authenticated={authenticated}
          />
          <Route
            path="/graphiql"
            title="GraphiQL"
            exact
            component={GraphiQL}
            authenticated={authenticated}
          />
          <Route
            path="/testing/notification/system"
            title="Testing"
            exact
            component={SystemNotification}
            authenticated={authenticated}
          />
          <ReactRouterRoute title="404" component={InvalidPath} />
        </Switch>
      </Root>
    </Router>
  </div>
);

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js